import { Component } from "react";
import { Link } from "react-router-dom";
import { IoEyeOutline, IoCartOutline } from "react-icons/io5";

class ProductSection extends Component {
  render() {
    // Note: Product array is dynamic
    const products = this.props.products || [
      {
        id: "prod-1",
        title: "XLP Student Basic Kit",
        info: "Details subject to change",
        price: "₹1080",
        image: "/assets/misc/xlp_mock_product.webp",
        viewLink: "/purchase_screen", //change
        buyLink: "/purchase_screen", //change
      },
      {
        id: "prod-2",
        title: "XLP Student Plus Kit",
        info: "Details subject to change",
        price: "₹2080",
        image: "/assets/misc/xlp_mock_product.webp",
        viewLink: "/product-details/1", //change
        buyLink: "/checkout/1", //change
      },
      // Note: Can add more products here
    ];

    return (
      <section
        className="py-5 mb-1"
        style={{
          background: "linear-gradient(125deg, #b54a2e 0%, #e06c48 100%)",
        }}
      >
        <div className="container">
          {/* Section Header */}
          <h2 className="text-white mb-4">Products</h2>

          {/* Responsive Grid */}
          <div className="row g-4">
            {products.map((product) => (
              <div
                className="col-12 col-sm-6 col-md-4 col-lg-3"
                key={product.id}
              >
                {/* The Card */}
                <div
                  className="card border-0 shadow-sm p-3 h-100 custom-card-hover"
                  style={{ borderRadius: "12px" }}
                >
                  {/* Product Image */}
                  <div
                    className="position-relative overflow-hidden"
                    style={{ borderRadius: "6px", backgroundColor: "#f8f9fa" }}
                  >
                    <img
                      src={product.image}
                      alt={product.title}
                      className="card-img-top img-fluid"
                      style={{ objectFit: "cover", aspectRatio: "4/3" }}
                    />
                  </div>

                  {/* Card Content */}
                  <div className="card-body p-0 pt-3 d-flex flex-column flex-grow-1">
                    {/* Product Title */}
                    <h6
                      className="card-title text-dark fw-normal mb-2 text-truncate"
                      title={product.title}
                    >
                      {product.title}
                    </h6>

                    {/* Product Info */}
                    <p
                      className="card-text text-secondary small mb-2 text-truncate"
                      title={product.title}
                    >
                      {product.info}
                    </p>

                    {/* Price */}
                    <span
                      className=" mb-3 d-block"
                      style={{ color: "#a7422a", fontSize: "16px" }}
                    >
                      {product.price}
                    </span>

                    {/* Action Buttons Container */}
                    <div className="d-flex gap-2 mt-auto pt-1">
                      {/* View Product Button (Outlined) */}
                      <Link
                        to={product.viewLink}
                        className="btn btn-outline-custom flex-grow-1 d-inline-flex align-items-center justify-content-center gap-1 px-2 py-2 text-decoration-none"
                        style={{
                          fontSize: "13px",
                          fontWeight: "500",
                          borderColor: "#a7422a",
                          color: "#a7422a",
                          borderRadius: "6px",
                        }}
                      >
                        View Product <IoEyeOutline size={16} />
                      </Link>

                      {/* Buy Now Button (Filled) */}
                      <Link
                        to={product.buyLink}
                        className="btn btn-brand-custom flex-grow-1 d-inline-flex align-items-center justify-content-center gap-1 px-2 py-2 text-decoration-none text-white"
                        style={{
                          fontSize: "13px",
                          fontWeight: "500",
                          backgroundColor: "#a7422a",
                          borderColor: "#a7422a",
                          borderRadius: "6px",
                        }}
                      >
                        Buy Now <IoCartOutline size={16} />
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    );
  }
}

export default ProductSection;
